import React from 'react';
import { Link } from 'react-router-dom';
import { services } from '../../data/services';
import Logo from '../Logo';

const WaIcon = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
    <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.126 1.533 5.858L.054 23.445a.75.75 0 00.922.922l5.587-1.479A11.94 11.94 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.907 0-3.7-.506-5.248-1.391l-.378-.22-3.917 1.036 1.036-3.917-.22-.378A9.952 9.952 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
  </svg>
);

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Col 1: Brand */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <Logo dark />
            </Link>
            <p className="text-sm leading-relaxed mb-6">
              Votre partenaire de confiance pour la rénovation dans le Berry (Indre & Cher). Garantie décennale sur tous nos chantiers.
            </p>
            <div className="flex items-center gap-3 mb-6">
              {[
                { label: 'Facebook', char: 'f' },
                { label: 'Instagram', char: '📷' },
                { label: 'LinkedIn', char: 'in' },
              ].map((s) => (
                <a
                  key={s.label}
                  href="/"
                  aria-label={s.label}
                  className="w-9 h-9 bg-slate-800 rounded-lg flex items-center justify-center text-slate-400 hover:bg-orange-600 hover:text-white transition-all duration-200 text-sm font-bold"
                >
                  {s.char}
                </a>
              ))}
            </div>
            <div className="flex flex-wrap gap-2">
              {/* RGE/Qualibat badges — à rétablir après obtention qualif
              <span className="bg-emerald-800/60 text-emerald-300 text-xs font-medium px-2.5 py-1 rounded-full">
                ✓ Certifié RGE
              </span>
              <span className="bg-blue-800/60 text-blue-300 text-xs font-medium px-2.5 py-1 rounded-full">
                ✓ Qualibat 9111
              </span>
              */}
              <span className="bg-purple-800/60 text-purple-300 text-xs font-medium px-2.5 py-1 rounded-full">
                ✓ Garantie Décennale
              </span>
            </div>
          </div>

          {/* Col 2: Services */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">
              Nos Services
            </h3>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service.slug}>
                  <Link
                    to={`/services/${service.slug}`}
                    className="text-sm hover:text-orange-400 transition-colors flex items-center gap-2"
                  >
                    <span className="text-orange-600/60">→</span>
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3: Information */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">
              Informations
            </h3>
            <ul className="space-y-2">
              {[
                { to: '/a-propos', label: 'À propos de nous' },
                { to: '/realisations', label: 'Nos Réalisations' },
                { to: '/blog', label: 'Blog & Conseils' },
                { to: '/devis', label: 'Devis Gratuit' },
                { to: '/contact', label: 'Nous Contacter' },
                { to: '/contact', label: 'Recrutement' },
                { to: '/mentions-legales', label: 'Mentions Légales' },
                { to: '/confidentialite', label: 'Politique de Confidentialité' },
              ].map((link, idx) => (
                <li key={idx}>
                  <Link
                    to={link.to}
                    className="text-sm hover:text-orange-400 transition-colors flex items-center gap-2"
                  >
                    <span className="text-orange-600/60">→</span>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4: Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">
              Nous Contacter
            </h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <span className="mt-0.5 text-orange-500">📍</span>
                <div className="text-sm">
                  <p>2 rue du Gué de la Chapelle</p>
                  <p>36250 Saint-Maur</p>
                  <a
                    href="https://maps.google.com/?q=2+rue+du+Gu%C3%A9+de+la+Chapelle+36250+Saint-Maur"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-orange-400 hover:text-orange-300 transition-colors text-xs mt-1 inline-block"
                  >
                    Voir sur Google Maps →
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <a href="/assistant" className="inline-flex items-center gap-1.5 px-4 py-2 text-sm font-semibold rounded-lg transition-colors border text-orange-400 border-orange-400/40 hover:bg-orange-400/10">
                  ✦ Assistant IA
                </a>
              </div>
              <div className="flex items-center gap-3">
                <span className="text-orange-500">✉️</span>
                <a
                  href="mailto:contact@apexrenovation.fr"
                  className="text-sm hover:text-white transition-colors"
                >
                  contact@apexrenovation.fr
                </a>
              </div>
              <div className="flex items-start gap-3">
                <span className="mt-0.5 text-orange-500">🕐</span>
                <div className="text-sm">
                  <p>Lun – Ven : 8h00 – 18h00</p>
                  <p className="text-slate-500">Sam – Dim : fermé</p>
                </div>
              </div>
            </div>
            <div className="mt-5">
              <Link
                to="/devis"
                className="block w-full text-center bg-orange-600 hover:bg-orange-700 text-white font-semibold px-5 py-2.5 rounded-lg transition-colors text-sm"
              >
                Devis Gratuit
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-slate-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} Apex Rénovation. Tous droits réservés. — SIRET 102 941 028 00015
          </p>
          <div className="flex items-center gap-4 text-xs text-slate-500">
            <Link to="/mentions-legales" className="hover:text-slate-300 transition-colors">
              Mentions légales
            </Link>
            <Link to="/confidentialite" className="hover:text-slate-300 transition-colors">
              Confidentialité
            </Link>
            <Link to="/cgv" className="hover:text-slate-300 transition-colors">
              CGV
            </Link>
            <Link to="/pro/login" className="hover:text-slate-300 transition-colors">
              Connexion
            </Link>
          </div>
          <p className="text-xs text-slate-500">
            Site fait avec <span className="text-orange-500">♥</span> en Indre
          </p>
        </div>
      </div>
    </footer>
  );
}
